/* NORDTRITT LANDING (ntl-) — gallery, varianti, sticky ATC */
(function () {
  'use strict';
  if (window.__ntlLanding) return;
  window.__ntlLanding = true;

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var slides = root.querySelector('[data-ntl-slides]');
    if (!slides) return;
    var thumbs = root.querySelectorAll('[data-ntl-thumb]');
    var items = slides.querySelectorAll('[data-ntl-slide]');

    function setActive(i) {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
      var t = thumbs[i];
      if (t && t.parentNode) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
    }
    function goTo(i) {
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      slides.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    function current() { return Math.round(slides.scrollLeft / slides.clientWidth); }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var prev = root.querySelector('[data-ntl-prev]'), next = root.querySelector('[data-ntl-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    var timer;
    slides.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { setActive(current()); }, 80);
    });
    root.ntlGoToMedia = function (mediaId) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-media-id') == mediaId) { goTo(i); return; }
      }
    };
  }

  /* ---------- Varianti ---------- */
  function formatMoney(cents, format) {
    format = format || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals.replace(/\./g, ','))
      .replace(/\{\{\s*amount\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1]);
  }

  function initProduct(section) {
    var dataEl = section.querySelector('[data-ntl-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var moneyFormat = section.getAttribute('data-money-format');
    var form = section.querySelector('[data-ntl-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var atc = section.querySelector('[data-ntl-atc]');
    var atcLabel = atc ? atc.querySelector('[data-ntl-atc-label]') : null;
    var priceEl = section.querySelector('[data-ntl-price]');
    var compareEl = section.querySelector('[data-ntl-compare]');
    var badgeEl = section.querySelector('[data-ntl-badge]');
    var gallery = section.querySelector('[data-ntl-gallery]');

    function selectedOptions() {
      var opts = [];
      section.querySelectorAll('[data-ntl-option]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-ntl-option'), 10);
        if (el.tagName === 'SELECT') opts[idx] = el.value;
        else if (el.checked) opts[idx] = el.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
      });
    }
    function update() {
      var v = findVariant(selectedOptions());
      section.querySelectorAll('[data-ntl-option-value]').forEach(function (el) {
        var idx = el.getAttribute('data-ntl-option-value');
        var sel = selectedOptions()[idx];
        if (sel) el.textContent = sel;
      });
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = atc.getAttribute('data-unavailable');
        return;
      }
      if (idInput) idInput.value = v.id;
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? atc.getAttribute('data-label') : atc.getAttribute('data-soldout');
      }
      if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.textContent = onSale ? formatMoney(v.compare_at_price, moneyFormat) : ''; compareEl.hidden = !onSale; }
      if (badgeEl) {
        if (onSale) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          badgeEl.textContent = badgeEl.getAttribute('data-template').replace('[percent]', pct);
        }
        badgeEl.hidden = !onSale;
      }
      if (v.featured_media && gallery && gallery.ntlGoToMedia) gallery.ntlGoToMedia(v.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('ntl:variant-change', { detail: v }));
    }
    section.querySelectorAll('[data-ntl-option]').forEach(function (el) { el.addEventListener('change', update); });

    /* Size chart modal */
    section.querySelectorAll('[data-ntl-open-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var m = document.getElementById(btn.getAttribute('data-ntl-open-modal'));
        if (m && m.showModal) m.showModal();
      });
    });
    document.querySelectorAll('[data-ntl-close-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () { btn.closest('dialog').close(); });
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initSticky(btn) {
    var target = document.querySelector('[data-ntl-atc]');
    if (!target) { btn.remove(); return; }
    var mode = btn.getAttribute('data-mode');
    btn.style.display = '';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var below = e.boundingClientRect.top < 0;
        btn.classList.toggle('is-visible', !e.isIntersecting && below);
      });
    });
    io.observe(target);
    btn.addEventListener('click', function () {
      if (mode === 'add' && !target.disabled) { target.click(); return; }
      var picker = document.querySelector('[data-ntl-variants]') || target;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      picker.classList.remove('ntl-flash'); void picker.offsetWidth; picker.classList.add('ntl-flash');
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ntl-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-ntl-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-ntl-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
